/* eslint-disable react/prop-types */
import { useState, createContext } from "react";

export const AuthContext = createContext({
  statusAuth: null,
  setStatusAuth: () => {},
  user: {},
  setUser: () => {},
  accessToken: null,
  refreshToken: null,
  csrftoken: null,
  setAccessToken: () => {},
  setRefreshToken: () => {},
  setCSRFToken: () => {},
});

export function AuthContextProvider(props) {
  const [user, setUser] = useState({});
  const [statusAuth, setStatusAuth] = useState(null);
  const [accessToken, setAccessToken] = useState();
  const [refreshToken, setRefreshToken] = useState();
  const [csrftoken, setCSRFToken] = useState();

  return (
    <AuthContext.Provider
      value={{
        setStatusAuth,
        statusAuth,
        user,
        setUser,
        accessToken,
        setAccessToken,
        refreshToken,
        setRefreshToken,
        csrftoken,
        setCSRFToken,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
